
import { Component, Vue } from "vue-property-decorator";
import AddServicepoint from "@/pages/servicepoint/ServicepointAddPage.vue";
import ServicepointsTable from "@/components/servicepoint/ServicepointsTable.vue";

@Component({
  name: "servicepoints-page",
  components: { AddServicepoint, ServicepointsTable },
})
export default class ServicepointsPage extends Vue {
  constructor() {
    super();
  }

  goToAddServicepoint = async (): Promise<void> => {
    await this.$router.push({
      name: "add-servicepoint",
    });
  };
}
